import profiles from 'src/constants/profileTypes';
import { object, string, ObjectSchema } from 'yup';

export default function makeValidationSchema(
  profileType?: string,
): ObjectSchema {
  const equalCharacterLicensePlate = 6;
  const maxCharacterVinNumber = 17;

  function createMaxRegex(maxCharacter: number): RegExp {
    return new RegExp(`^.{0,${maxCharacter}}$`);
  }

  function createEqualCantRegex(maxCharacter: number): RegExp {
    return new RegExp(`^[a-zA-Z0-9]{${maxCharacter}}$`);
  }

  if (profileType === profiles.RETENCION) {
    return object().shape({
      vinNumber: string()
        .required('El campo de número de chasis es obligatorio')
        .min(10, 'El campo de número de chasis debe tener mínimo 10 caracteres')
        .matches(createMaxRegex(maxCharacterVinNumber), {
          message: `La cantidad de caracteres no puede ser mayor a ${maxCharacterVinNumber}`,
        }),
      licensePlate: string()
        .required('El campo de placa es obligatorio')
        .matches(createEqualCantRegex(equalCharacterLicensePlate), {
          message: `La cantidad de carácteres debe ser igual a ${equalCharacterLicensePlate}`,
        }),
    });
  }

  return object().shape({
    vinNumber: string()
      .required('El campo de número de chasis es obligatorio')
      .min(10, 'El campo de número de chasis debe tener mínimo 10 caracteres')
      .matches(createMaxRegex(maxCharacterVinNumber), {
        message: `La cantidad de caracteres no puede ser mayor a ${maxCharacterVinNumber}`,
      }),
  });
}
